import { BaseApi, ApiResponse } from "../utils/request";

// 清除审核配置
export interface ClearAuditConfig {
  enabled: boolean;
  disableClearAudit: boolean;
  limitCurrencyDenyModel: boolean;
  clearAuditFactor: number;
  limitPlatformDenyModel: boolean;
}

// 定时配置
export interface ScheduledConfig {
  enabled: boolean;
  dateRange: {
    start: number;
    finish: number;
  };
}

// 平台信息
export interface Platform {
  id: string;
  created: number;
  modified: number;
  name: string;
  soId: string;
  supportDemo: boolean;
  maintain: boolean;
  estimateRatio: number;
  thirdRtp?: number;
  noAddAudit: boolean;
  disableEmbed: boolean;
  countryIds?: string[];
  currencyIds?: string[];
  clearAuditConfig: ClearAuditConfig;
  scheduledConfig?: ScheduledConfig;
  apiConnected: boolean;
}

// 返现信息
export interface CashBack {
  gameId?: string;
  platformId: string;
  platform: Platform;
  ratio: number;
  auditRatio: number;
  type: string;
  backAmount?: number;
  userCashbackRecord?: boolean;
}

export interface CashbackClaimRequest {
  id: string;
  type: string;
  date?: number | null;
}

// 签到数据
export interface CheckInData {
  inDays: number;
  betAmount: number;
  rechargeAmount: number;
  dayAmounts: number[];
}

// 奖励任务（签到）
export interface BonusTask {
  id: string;
  created: number;
  modified: number;
  countryId: string;
  abFlag: boolean;
  name: string;
  icon?: string;
  vipCondType: string;
  vipLevel: number;
  includeBadUser: boolean;
  times: string;
  auditRatio: number;
  type: string;
  checkInData: CheckInData;
  sort: number;
  enabled: boolean;
}

// 周贡献
export interface WeeklyContribution {
  weeklyRecharge: number;
  weeklyBet: number;
  weeklyContributionAmount: number;
  canClaim: boolean;
  claimed: boolean;
}

// 月贡献
export interface MonthlyContribution {
  monthlyRecharge: number;
  monthlyBet: number;
  monthlyContributionAmount: number;
  monthlyContributionCap?: number;
  canClaim: boolean;
  claimed: boolean;
}

// 用户签到记录
export interface UserCheckIn {
  data: {
    day: number;
  };
}

// VIP等级信息
export interface VipLevel {
  id: string;
  created: number;
  modified: number;
  name: string;
  level: number;
  icon: string;
  rechargeAmount: number;
  betAmount: number;
  auditRatio: number;
  limitCountryIds?: string[];
  limitBrandIds?: string[];
  withdrawOneDay: number;
  withdrawFeeRate: number;
  minWithdrawFee: number;
  maxBetAmountOnce: number;
  reward: number;
  enableWithdrawVipLimitNotice: boolean;
  cashBackList: CashBack[];
  bonusTaskCheckInDay?: BonusTask;
  todayCheckIn: boolean;
  userCheckIn?: any;
  weeklyContribution?: WeeklyContribution;
  monthlyContribution?: MonthlyContribution;
  canClaim: boolean;
  rewardClaimed: boolean;
}

// 审核进度
export interface AuditProgress {
  total: number;
  finished: number;
  real: number;
  bonus: number;
  left: number;
}

// VIP列表响应
export interface VipListResponse {
  betAmount: number;
  rechargeAmount: number;
  withdrawAmount: number;
  availableBalance: number;
  levelList: VipLevel[];
  auditProgress: AuditProgress;
  canClaimCount?: number;
}
/**
 * VIP API 类
 * 继承 BaseApi，提供VIP相关的 API 接口
 */
export class VipApi extends BaseApi {
  constructor() {
    super();
  }

  /**
   * 获取VIP信息
   * @returns Promise<ApiResponse<VipInfo, true>>
   */

  /**
   * 获取VIP列表
   * @returns Promise<ApiResponse<VipListResponse, true>>
   */
  async getVipList(): Promise<ApiResponse<VipListResponse, true>> {
    return this.post<VipListResponse, true>("/api/v1/vip_center", {});
  }

  async receiveReward(level: number): Promise<ApiResponse<any, true>> {
    return this.post<any, true>(`/api/v1/vip_bonus`, { level });
  }

  async claimVipReward(
    level: number,
    type: string
  ): Promise<ApiResponse<any, true>> {
    return this.post<any, true>(`/api/v1/claimVipReward`, { level, type });
  }

  async receiveRebate(
    body: CashbackClaimRequest
  ): Promise<ApiResponse<any, true>> {
    return this.post<any, true>(`/api/v1/get_cashback`, body);
  }
  async checkIn(): Promise<ApiResponse<any, true>> {
    return this.post<any, true>(
      `/api/v1/check_in`,
      {},
      {
        attachApiExtraOnBizError: true,
      }
    );
  }
}

export const vipApi = new VipApi();
export const checkIn = () => vipApi.checkIn();
export const receiveReward = (level: number) => vipApi.receiveReward(level);

export const claimVipReward = (level: number, type: string) =>
  vipApi.claimVipReward(level, type);

export const receiveRebate = (body: CashbackClaimRequest) =>
  vipApi.receiveRebate(body);
export const getVipList = () => vipApi.getVipList();
